import { defaultCardsBlock, defaultPageHeaderBlock } from '@builder/defaults'
import { Block, BlockType } from '@builder/types'

const useBuilder = () => {
    const generateBlockKey = (): string => {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
            /[xy]/g,
            (char) => {
                const random = Math.floor(Math.random() * 16)
                const value = char === 'x' ? random : (random & 0x3) | 0x8
                return value.toString(16)
            }
        )
    }

    const getDefaultBlockData = (blockType: BlockType): Block => {
        switch (blockType) {
            case 'cards':
                return defaultCardsBlock(generateBlockKey())
            case 'pageHeader':
                return defaultPageHeaderBlock(generateBlockKey())
            default:
                return {} as Block
        }
    }

    return {
        generateBlockKey,
        getDefaultBlockData,
    }
}

export default useBuilder
